var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Search","dense":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._l((_vm.groups),function(group,index){return _c('Block',{key:index,staticClass:"my-3",attrs:{"title":group.title,"items":group.items,"search":_vm.search}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }